import React from 'react'

export function withDisplayCondition(WrappedComponent: any, condition: any)
{
	function WithDataQuery(props: any) {
		if (!condition(props)) {
			return null
		}

		return (
			<WrappedComponent {...props} />
		)
	}

	WithDataQuery.displayName = `withDisplayCondition(${WrappedComponent.name})`

	return WithDataQuery
}
